export default class CommonUtil {

    static hasInfoStatus(status: string) {
       const hasStatus = ['Saved', 'Submitted'].includes(status);
       return !hasStatus;
    }

    // Overtime (OTE) entries are derived by copying the parent timesheet, so their
    // time in/out and clock locations are not meaningful and should be shown as '-'.
    // OTE service codes contain the token '-OTE' (e.g. 'XXX-OTE'); requiring the
    // hyphen avoids false positives on description words such as 'remote'/'note'.
    static isOvertimeServiceCode(serviceCode: any): boolean {
       return typeof serviceCode === 'string' && serviceCode.toUpperCase().includes('-OTE');
    }

    // Different timesheet grids/forms hold the service code in different shapes:
    // a string (most grids), a lookup object with lkpValueName (adjust/void form),
    // or under serviceDescription (adjustment/resurrect grids). Check all of them.
    static isOvertimeRow(row: any): boolean {
       if (!row) {
          return false;
       }
       const serviceCode = typeof row.serviceCode === 'object' && row.serviceCode
          ? row.serviceCode.lkpValueName
          : row.serviceCode;
       return this.isOvertimeServiceCode(serviceCode) || this.isOvertimeServiceCode(row.serviceDescription);
    }
}